module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-500.1b2196a.ttf";